import { uploadModel } from '@/libs/loadModel';
import { v3dMesh } from '@/Interfaces/common';

export class ModelCache {
    modelCache: Map<string, v3dMesh>;

    constructor() {
        this.modelCache = new Map();
    }

    //НЕ загружаем модели, если модели загружены уже в modelCache
    async getOrUploadModelByName(newName: string): Promise<v3dMesh|undefined> {
        let model = this.modelCache.get(newName);
        if (!model) model = await uploadModel(newName) as v3dMesh;
        return model;
    }
    getModelByName(newName: string): v3dMesh|undefined {
        return this.modelCache.get(newName);
    }
    get modalCache() {
        return this.modelCache;
    }
    setModalCache(blenderName: string, model: v3dMesh) {
        this.modelCache.set(blenderName, model);
    }

    isHas(blenderName: string) {
        return this.modelCache.has(blenderName);
    }
    destroy() {
        this.modelCache.forEach((obj) => {
            obj.geometry?.dispose();
            obj.material?.dispose();
            obj.removeFromParent();
            // obj = null;
        });
        this.modelCache.clear();
    }
}